<template>

  <!-- 매니저 -->
  <div class="side_menu_wr">
    <!-- 접속중인 페이지에 해당하는 목록에 current_page 클래스 추가 -->
    <router-link to="/" class="d-flex al-cnt current_page menu_item">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="15.7" height="15.7" viewBox="0 0 15.7 15.7"><path d="M15.4,6.5,11.1,1.6a4.1,4.1,0,0,0-6.2,0L.6,6.5A1.6,1.6,0,0,0,1.8,9.2H2V14c0,.9.6,1.8,2.4,1.8h7.8A1.8,1.8,0,0,0,14,14V9.2h.2a1.6,1.6,0,0,0,1.5-1A1.4,1.4,0,0,0,15.4,6.5ZM6.8,14.6V11a1.2,1.2,0,0,1,2.4,0v3.6ZM14.2,8h-.8l-.4.2a.5.5,0,0,0-.2.4V14a.6.6,0,0,1-.6.6H10.4V11a2.4,2.4,0,0,0-4.8,0v3.6H4.4c-.4,0-1.2,0-1.2-.6V8.6A.6.6,0,0,0,2.6,8H1.8a.4.4,0,0,1-.3-.7l4.3-5A2.9,2.9,0,0,1,8,1.3a2.9,2.9,0,0,1,2.2,1.1l4.3,4.9C14.7,7.6,14.6,8,14.2,8Z" transform="translate(-0.2 -0.2)" style="fill:#fdb913"/></svg>
      <h4>Dashboard</h4>
    </router-link>

    <a href="#" class="d-flex al-cnt menu_item" @click="openSubMenu(0)">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="16" height="14.4" viewBox="0 0 16 14.4"><path d="M12.3,15.1H3.7A3.8,3.8,0,0,1,0,11.4V4.5A3.8,3.8,0,0,1,3.7.7h8.6A3.8,3.8,0,0,1,16,4.5v6.9A3.8,3.8,0,0,1,12.3,15.1ZM3.7,2.4A2.1,2.1,0,0,0,1.6,4.5v6.9a2.2,2.2,0,0,0,2.1,2.1h8.6a2.2,2.2,0,0,0,2.1-2.1V4.5a2.1,2.1,0,0,0-2.1-2.1Z" transform="translate(0 -0.7)" style="fill:#fdb913"/><path d="M7.8,6.4H4.1a.8.8,0,0,1-.8-.8.8.8,0,0,1,.8-.9H7.8a.8.8,0,0,1,.8.9A.8.8,0,0,1,7.8,6.4Z" transform="translate(0 -0.7)" style="fill:#fdb913"/><path d="M9.6,9.5H4.1a.8.8,0,0,1-.8-.8.7.7,0,0,1,.8-.8H9.6a.8.8,0,0,1,.8.8A.9.9,0,0,1,9.6,9.5Z" transform="translate(0 -0.7)" style="fill:#fdb913"/></svg>
      <h4>회의 & 스마트룸 </h4>
      <i class="xi-angle-down-min"></i>
    </a>
    <ul class="w-100p sub_menu off">
      <!-- <li onclick="location.href='../meeting.php'">회의관리</li>
      <li onclick="location.href='../meeting_review.php'">리뷰관리</li> -->
      <li><router-link to="/conference">회의 관리</router-link></li>
      <li><router-link to="/room_list">스마트룸</router-link></li>
<!--      <li><router-link to="/reserve">예약 현황</router-link></li>-->
<!--      <li><router-link to="/smart_board">스마트룸 공지</router-link></li>-->
    </ul>

    <a href="#" class="d-flex al-cnt menu_item" @click="openSubMenu(1)">
      <svg class="menu_icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="15.8" height="15.8" viewBox="0 0 15.8 15.8"><path d="M15.7,11.9a8.6,8.6,0,0,0-3.8-4.4A4.3,4.3,0,0,0,12.6,5,4.8,4.8,0,0,0,7.9.1,4.8,4.8,0,0,0,3.2,5,5,5,0,0,0,4,7.6,8.4,8.4,0,0,0,.3,12a3.2,3.2,0,0,0,.3,2.7,2.9,2.9,0,0,0,2.3,1.2H13.1a2.8,2.8,0,0,0,2.3-1.3,3,3,0,0,0,.5-1.6A4.3,4.3,0,0,0,15.7,11.9ZM7.9,1.9a3.1,3.1,0,0,1,3,3.1,3.2,3.2,0,0,1-1,2.2h0a3.2,3.2,0,0,1-2,.8,2.8,2.8,0,0,1-2-.8A3.2,3.2,0,0,1,4.9,5,3.1,3.1,0,0,1,7.9,1.9ZM14,13.6a1.2,1.2,0,0,1-.9.5H2.9a1.1,1.1,0,0,1-.9-.5.9.9,0,0,1-.1-.9A6.4,6.4,0,0,1,5.2,9l.4.2.6.3A4.6,4.6,0,0,0,10,9.3h0l.4-.2.3-.2a6.5,6.5,0,0,1,3.4,3.7A1.2,1.2,0,0,1,14,13.6Z" transform="translate(-0.1 -0.1)" style="fill:#fdb913"/></svg>
      <h4>조직/멤버관리</h4>
      <i class="xi-angle-down-min"></i>
    </a>
    <ul class="w-100p sub_menu off">
      <li><router-link to="/member">멤버 관리</router-link></li>
      <li><router-link to="/part">부서 관리</router-link></li>
      <!-- <li><router-link to="/invite">맴버 초대</router-link></li> -->

      <li><router-link to="/position">직급 관리</router-link></li>

<!--      <li><router-link to="/review_config_list">리뷰 관리</router-link></li>-->
    </ul>

  </div>

</template>

<script>
export default {
  name: "SideMenuManger",
  methods: {
    openSubMenu( subMenu ){
      const sub_menu = document.querySelectorAll(".sub_menu");
      sub_menu[subMenu].classList.toggle('off');
    },
    checkMenu( path ){
      const ary = [
        ["/conference", "room_list"],
        ["/member", "/part", "/invite", "/position", "/review_config_list"]
      ];
      let findKey = 0;
      ary.forEach((word, key)=>{
        if( word.find(e => e === path) !== undefined ){
          findKey = key;
        }
      })
      this.openSubMenu(findKey);
    }

  },
  mounted() {
    this.checkMenu( this.$route.path );
  }
}
</script>

<style scoped>
.off {
  display: none;
}
</style>
